// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Ger","badges":"styles_badges__3JXT_"};